import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { TState, useActions } from './redux/store';

// eslint-disable-next-line @typescript-eslint/no-unused-vars

import majsList from './components/table/actions/majs/majsList';
import { useAllTabs } from './redux/actions';
import { momentTimezone } from './components/utils/dateUtils';

const MAX_MOBILE_SIZE = 480;
const MAX_TABLET_SIZE = 1200;

const InitApp = () => {
  const token = useSelector((state: TState) => state.token);
  const isOpen = useSelector((state: TState) => state.isOpen);
  const currentTab = useSelector((state: TState) => state.currentTab);
  const tabs = useSelector((state: TState) => state.tabs);
  const modalType = useSelector((state: TState) => state.modalType);
  const login = useSelector((state: TState) => state.login);
  const user = useSelector((state: TState) => state.user);
  const settingsTabs = useSelector((state: TState) => state.settingsTabs);
  const isEditMode = useSelector((state: TState) => state.isEditMode);
  const themeColor = useSelector((state: TState) => state.theme);
  const calendarCurrentDay = useSelector(
    (state: TState) => state.calendarCurrentDay,
  );

  const allTabs = useAllTabs();

  const firstDayOfWeek = useRef(calendarCurrentDay);

  const {
    setGlobalFilter,
    setCurrentTab,
    setRowData,
    setIsMobile,
    setIsTablet,
    onOpen,
    setModalType,
    setPlanningAddress,
    getUsersList,
    getInputs,
    getDocumentList,
    getTabs,
    getData,
    getUserRoleContext,
    fetchAppointments,
    setTabToUpdate,
    setAppointsHistory,
    setRowHistory,
    setFilesStatus,
    setFilesComms,
    setTheme,
    getNotifs,
    getRolesList,
    setRowSelected,
    getActionsList,
  } = useActions();

  useEffect(() => {
    token && !login && getUserRoleContext();

    if (token && login) {
      const changeLogLastVersion =
        localStorage.getItem('changeLogLastVersion') || 0;

      const lastMaj = majsList.length;
      const needMajModal = lastMaj > Number(changeLogLastVersion);

      needMajModal && setModalType('displayMajs');

      setTimeout(() => {
        localStorage.setItem('changeLogLastVersion', `${lastMaj}`);
      }, 1000);
    }
  }, [token, login]);

  useEffect(() => {
    if (token && user?._id) {
      getUsersList({ forced: true });
      getTabs();
      getDocumentList({ forced: true });

      if (!user?.isSuper) {
        user.isNotif && getNotifs();
        getInputs({ forced: true });
        getActionsList();
      }

      const settings = { ...themeColor, ...user.settings };
      setTheme(settings);
    }
  }, [user?._id]);

  useEffect(() => {
    const newFirstDayOfWeek =
      momentTimezone(calendarCurrentDay).startOf('isoWeek');
    // const newWeek = !newFirstDayOfWeek.isSame(firstDayOfWeek.current, 'date');
    if (currentTab?.isPlanning || /addToPlanning/.test(modalType)) {
      firstDayOfWeek.current = newFirstDayOfWeek.toISOString();
      fetchAppointments(newFirstDayOfWeek);
    }
  }, [calendarCurrentDay]);

  useEffect(() => {
    const localCurrent = localStorage.getItem('currentTab');
    const prevTab = allTabs[localCurrent || ''] || tabs[0] || {};
    const customPrev = prevTab?.isSetting || prevTab?.isPlanning;
    const customCurr = currentTab?.isSetting || currentTab?.isPlanning;
    const needResetSearch =
      (customPrev && !customCurr) || (customCurr && !customPrev);

    if (needResetSearch) {
      setGlobalFilter('');
    }

    const customTab = currentTab?.isSetting || currentTab?.isPlanning;

    if (currentTab?.isAuthOnlyChild) {
      setCurrentTab(currentTab.menuChilds?.[0]);
      return;
    }

    if (!customTab && !isEditMode) {
      getData();
    }

    if (!currentTab?.isSetting) {
      setTabToUpdate(currentTab);
    }

    setRowSelected([]);
    currentTab?._id && localStorage.setItem('currentTab', currentTab?._id);
  }, [currentTab?._id]);

  useEffect(() => {
    if (currentTab?.isSetting) {
      setTabToUpdate(settingsTabs[0]);
    }
  }, [currentTab]);

  useEffect(() => {
    const localCurrent = localStorage.getItem('currentTab');
    setCurrentTab(allTabs[localCurrent || ''] || tabs[0]);
  }, [allTabs]);

  useEffect(() => {
    window.addEventListener('resize', () => {
      setIsMobile(window.innerWidth < MAX_MOBILE_SIZE);
      setIsTablet(
        window.innerWidth >= MAX_MOBILE_SIZE &&
          window.innerWidth < MAX_TABLET_SIZE,
      );
    });
  }, []);

  useEffect(() => {
    if (modalType) {
      onOpen();
    }
  }, [modalType]);

  useEffect(() => {
    if (!isOpen) {
      setAppointsHistory({});
      setRowHistory({});
      setFilesStatus({});
      setFilesComms({});
      setRowData({});
      setModalType('');
      setPlanningAddress('');
      // setModalData();
    }
  }, [isOpen]);

  useEffect(() => {
    isEditMode && getRolesList();
  }, [isEditMode]);

  return <></>;
};

export default InitApp;
